import { render, staticRenderFns } from "./ContactLayoutDetails.vue?vue&type=template&id=eb07d7c4&scoped=true"
import script from "./ContactLayoutDetails.vue?vue&type=script&lang=js"
export * from "./ContactLayoutDetails.vue?vue&type=script&lang=js"
import style0 from "./ContactLayoutDetails.vue?vue&type=style&index=0&id=eb07d7c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb07d7c4",
  null
  
)

export default component.exports